export default "__VITE_ASSET__Ceg4fRmk__"